<div
  [style]="{
    width: size() + 'px',
    height: size() + 'px',
    minWidth: size() + 'px',
    minHeight: size() + 'px',
    maxWidth: size() + 'px',
    maxHeight: size() + 'px'
  }"
  [ngClass]="{
    'text-sm': size() < 50,
    'text-lg': size() > 50 && size() < 60,
    'text-2xl': size() > 60,
    'ring-4 ring-white': ring() && !src(),
    'border border-white/70': border() && !src(),
    'p-2': !src(),
    'from-primary-800 to-primary-900 via-primary-500 ': !src()
  }"
  class="flex overflow-hidden text-white transition-all bg-gradient-to-br rounded-full outline-none flex-center {{
    containerClass()
  }}"
>
  <img
    [src]="src()"
    *ngIf="src()"
    crossorigin="anonymous"
    (error)="onImageError()"
    [ngClass]="imageClass()"
    class="object-cover w-full h-full rounded-full"
  />
  <b translate="no" *ngIf="!src()" class="">{{ initials() }}</b>
</div>
